import { SparklineXAxisProps } from '../types/sparkline-x-axis-props.js';

export const XAxis = (_: SparklineXAxisProps) => null;
